import { useEffect } from 'react';
let locks = 0;
let previousBodyOverflow = '';
let previousRootOverflow = '';
/** Shared across nested app and money dialogs; the last dialog restores the page. */
export function useCashDialog(ref, { preserveScroll = false } = {}) {
    useEffect(() => {
        const dialog = ref.current;
        const previousFocus = document.activeElement;
        const previousScroll = { left: window.scrollX, top: window.scrollY, behavior: 'instant' };
        const root = document.documentElement, previousGutter = root.style.getPropertyValue('scrollbar-gutter'), gutterPriority = root.style.getPropertyPriority('scrollbar-gutter');
        const reserveGutter = preserveScroll && root.clientWidth > 0 && window.innerWidth > root.clientWidth;
        if (reserveGutter)
            root.style.setProperty('scrollbar-gutter', 'stable');
        if (locks++ === 0) {
            previousBodyOverflow = document.body.style.overflow;
            previousRootOverflow = document.documentElement.style.overflow;
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        }
        dialog?.showModal();
        if (preserveScroll)
            window.scrollTo(previousScroll);
        return () => {
            dialog?.close();
            if (--locks === 0) {
                document.body.style.overflow = previousBodyOverflow;
                document.documentElement.style.overflow = previousRootOverflow;
            }
            if (reserveGutter) {
                if (previousGutter)
                    root.style.setProperty('scrollbar-gutter', previousGutter, gutterPriority);
                else
                    root.style.removeProperty('scrollbar-gutter');
            }
            if (previousFocus?.isConnected) {
                if (preserveScroll)
                    previousFocus.focus({ preventScroll: true });
                else
                    previousFocus.focus();
            }
            if (preserveScroll)
                window.scrollTo(previousScroll);
        };
    }, [ref, preserveScroll]);
}
